export default __webpack_public_path__ + "static/media/ph.d57bda10.jpg";